import { Link } from "react-router-dom";

/**
 * Footer with a HIDDEN admin entry point — the © symbol is clickable
 * and routes to /admin/login. It looks like normal copyright text.
 * No visible "Admin Login" anywhere.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-neutral-900 mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] font-mono uppercase tracking-[0.25em] text-neutral-600">
        <div>
          <Link
            to="/admin/login"
            data-testid="footer-admin-entry"
            aria-label="copyright"
            className="hover:text-neutral-400 transition-colors cursor-pointer select-none"
          >©</Link>
          <span className="ml-1">{year} ChartLenz · all rights reserved</span>
        </div>
        <div className="flex items-center gap-3">
          <span>chart intelligence terminal</span>
        </div>
      </div>
    </footer>
  );
}
